import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { RouterProvider } from '@tanstack/react-router'
import { ThemeProvider } from '@/app/theme-provider'
import { SmoothScrollProvider } from '@/app/smooth-scroll-provider'
import { router } from '@/app/router'
import { ErrorBoundary } from '@/components/common/error-boundary'
import '@/styles/globals.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <SmoothScrollProvider>
          <HelmetProvider>
            <RouterProvider router={router} />
          </HelmetProvider>
        </SmoothScrollProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
)
